import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';


const ListItem = (props) => {
  return (
    <li className={classNames({ disabled: props.disabled })}>
      {props.disabled &&
        <div>
            <span>{props.title}</span>
            {props.children}
        </div>
      }
      {!props.disabled &&
        <Link to={props.to}>
          <div className="title">{props.title}</div>
          {props.children}
          <i className="bi_interface-right" />
        </Link>
      }
    </li>
  );
};

ListItem.propTypes = {
  disabled: PropTypes.bool,
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
ListItem.defaultProps = {
  disabled: false,
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/list-item.js